import * as ambassadorWixDocumentManagementEditorDeploymentsV1Deployment from './document-management-editor-deployments-v1-deployment-deployments.http.js';
import * as ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentTypes from './document-management-editor-deployments-v1-deployment-deployments.types.js';
import * as ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentUniversalTypes from './document-management-editor-deployments-v1-deployment-deployments.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createDeployment(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentUniversalTypes.CreateDeploymentRequest,
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentTypes.CreateDeploymentRequest,
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentUniversalTypes.CreateDeploymentResponse,
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentTypes.CreateDeploymentResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDocumentManagementEditorDeploymentsV1Deployment.createDeployment(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/deployments',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getDeployment(): __PublicMethodMetaInfo<
  'GET',
  { deploymentId: string },
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentUniversalTypes.GetDeploymentRequest,
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentTypes.GetDeploymentRequest,
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentUniversalTypes.GetDeploymentResponse,
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentTypes.GetDeploymentResponse
> {
  const payload = { deploymentId: ':deploymentId' } as any;

  const getRequestOptions =
    ambassadorWixDocumentManagementEditorDeploymentsV1Deployment.getDeployment(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/deployments/{deploymentId}',
    pathParams: { deploymentId: 'deploymentId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function publishDeployment(): __PublicMethodMetaInfo<
  'POST',
  { deploymentId: string },
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentUniversalTypes.PublishDeploymentRequest,
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentTypes.PublishDeploymentRequest,
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentUniversalTypes.PublishDeploymentResponse,
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentTypes.PublishDeploymentResponse
> {
  const payload = { deploymentId: ':deploymentId' } as any;

  const getRequestOptions =
    ambassadorWixDocumentManagementEditorDeploymentsV1Deployment.publishDeployment(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/deployments/{deploymentId}',
    pathParams: { deploymentId: 'deploymentId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function publishRcDeployment(): __PublicMethodMetaInfo<
  'POST',
  { deploymentId: string },
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentUniversalTypes.PublishRCDeploymentRequest,
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentTypes.PublishRCDeploymentRequest,
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentUniversalTypes.PublishRCDeploymentResponse,
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentTypes.PublishRCDeploymentResponse
> {
  const payload = { deploymentId: ':deploymentId' } as any;

  const getRequestOptions =
    ambassadorWixDocumentManagementEditorDeploymentsV1Deployment.publishRcDeployment(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/deployments/rc/{deploymentId}',
    pathParams: { deploymentId: 'deploymentId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listDeployments(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentUniversalTypes.ListDeploymentsRequest,
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentTypes.ListDeploymentsRequest,
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentUniversalTypes.ListDeploymentsResponse,
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentTypes.ListDeploymentsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDocumentManagementEditorDeploymentsV1Deployment.listDeployments(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/deployments',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryDeployments(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentUniversalTypes.QueryDeploymentsRequest,
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentTypes.QueryDeploymentsRequest,
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentUniversalTypes.QueryDeploymentsResponse,
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentTypes.QueryDeploymentsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDocumentManagementEditorDeploymentsV1Deployment.queryDeployments(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/deployments/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function reportDeploymentPipelineResult(): __PublicMethodMetaInfo<
  'POST',
  { deploymentId: string },
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentUniversalTypes.ReportDeploymentPipelineResultRequest,
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentTypes.ReportDeploymentPipelineResultRequest,
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentUniversalTypes.ReportDeploymentPipelineResultResponse,
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentTypes.ReportDeploymentPipelineResultResponse
> {
  const payload = { deploymentId: ':deploymentId' } as any;

  const getRequestOptions =
    ambassadorWixDocumentManagementEditorDeploymentsV1Deployment.reportDeploymentPipelineResult(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/deployments/pipeline/{deploymentId}/report-result',
    pathParams: { deploymentId: 'deploymentId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getDeploymentPipelineDescription(): __PublicMethodMetaInfo<
  'GET',
  { deploymentId: string },
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentUniversalTypes.GetDeploymentPipelineDescriptionRequest,
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentTypes.GetDeploymentPipelineDescriptionRequest,
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentUniversalTypes.GetDeploymentPipelineDescriptionResponse,
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentTypes.GetDeploymentPipelineDescriptionResponse
> {
  const payload = { deploymentId: ':deploymentId' } as any;

  const getRequestOptions =
    ambassadorWixDocumentManagementEditorDeploymentsV1Deployment.getDeploymentPipelineDescription(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/deployments/pipeline/{deploymentId}',
    pathParams: { deploymentId: 'deploymentId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateExtendedFields(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentUniversalTypes.UpdateExtendedFieldsRequest,
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentTypes.UpdateExtendedFieldsRequest,
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentUniversalTypes.UpdateExtendedFieldsResponse,
  ambassadorWixDocumentManagementEditorDeploymentsV1DeploymentTypes.UpdateExtendedFieldsResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixDocumentManagementEditorDeploymentsV1Deployment.updateExtendedFields(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/deployments/{id}/update-extended-fields',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}
